import flagsConfig from '../config/flags.json';

export interface FeatureFlags {
  LEARN_TAB: boolean;
  MULTI_PROVINCE: boolean;
  MULTI_ENTITY: boolean;
  AUTO_PDF_EXPORT: boolean;
  OCR_RECEIPTS: boolean;
  USE_STRIPE_BUY_BUTTONS: boolean;
}

/**
 * Get all feature flags
 */
export const getFlags = (): FeatureFlags => {
  return flagsConfig as FeatureFlags;
};

/**
 * Check if a specific feature flag is enabled
 */
export const isFeatureEnabled = (flag: keyof FeatureFlags): boolean => {
  const flags = getFlags();
  return flags[flag] || false;
};

/**
 * Get available provinces based on feature flags
 */
export const getAvailableProvinces = (): string[] => {
  const flags = getFlags();

  // Base provinces that are always available
  const baseProvinces = ['ON', 'BC', 'AB'];

  if (!flags.MULTI_PROVINCE) {
    return ['ON']; // Default to Ontario only
  }

  // Add staged provinces based on flags
  const availableProvinces = [...baseProvinces];

  // Always include MB for PST support
  availableProvinces.push('MB');

  return availableProvinces;
};

/**
 * Check if provincial tax filing is supported for a province
 */
export const isProvincialTaxFilingSupported = (provinceCode: string): boolean => {
  // All supported provinces (ON, AB, BC, MB) have tax filing support
  return ['ON', 'AB', 'BC', 'MB'].includes(provinceCode);
};

/**
 * Get entity types based on feature flags
 */
export const getAvailableEntityTypes = (): string[] => {
  const flags = getFlags();

  if (!flags.MULTI_ENTITY) {
    return ['SOLE_PROP']; // Phase-1: Sole proprietor only
  }

  return ['SOLE_PROP', 'PARTNERSHIP', 'CORPORATION'];
};

export default {
  getFlags,
  isFeatureEnabled,
  getAvailableProvinces,
  isProvincialTaxFilingSupported,
  getAvailableEntityTypes,
};
